import { useQuery } from "@tanstack/react-query"
import { amphoraIntegrationQuery } from "../../lib/amphora/amphoraIntegrationQuery"

export function useAmphoraIntegrationQuery(...args: Parameters<typeof amphoraIntegrationQuery>) {
  return useQuery(amphoraIntegrationQuery(...args))
}
